export const expiredPeriodsMap = new Map([
  ['1', { key: '1', text: '1 день', value: [1], min: 1, max: 1 }],
  ['2', { key: '2', text: '2 дня', value: [2], min: 2, max: 2 }],
  ['3', { key: '3', text: '3 дня', value: [3], min: 3, max: 3 }],
  ['4', { key: '4', text: '4-5 дней', value: [4], min: 4, max: 5 }],
  ['5', { key: '5', text: '6-10 дней', value: [5], min: 6, max: 10 }],
  [
    '6',
    {
      key: '6',
      text: 'Больше 10-ти дней',
      value: [6],
      min: 11,
      max: Infinity,
    },
  ],
  ['', { key: 'all', text: 'Без учета периода', value: [] }],
]);
